'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnorderedList;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContent = function getContent(type, info) {
  if (Array.isArray(info) && info.length > 0 || type == 'single') {
    switch (type) {
      case "address":
        return _react2.default.createElement(
          'ul',
          { className: 'listing' },
          info.map(function (item, key) {
            return _react2.default.createElement(
              'li',
              { key: key },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: item.url },
                  item.title
                )
              ),
              _react2.default.createElement(
                'address',
                null,
                !item.address.city || !item.address.state ? 'Multiple' : item.address.city + ', ' + item.address.state
              )
            );
          })
        );
        break;
      case "percent":
        return _react2.default.createElement(
          'ul',
          { className: 'listing' },
          info.map(function (item, key) {
            return _react2.default.createElement(
              'li',
              { key: key },
              _react2.default.createElement(
                'p',
                null,
                item.percent
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: item.url },
                  item.title
                )
              )
            );
          })
        );
        break;
      case "single":
        return _react2.default.createElement(
          'ul',
          { className: 'listing' },
          info.map(function (item, key) {
            return _react2.default.createElement(
              'li',
              { key: key },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: item.url },
                  item.title
                )
              )
            );
          })
        );
        break;
    }
  }

  return _react2.default.createElement(
    'p',
    null,
    'Sorry, no location found.'
  );
};

function UnorderedList(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      heading1 = _ref.heading1,
      heading2 = _ref.heading2,
      location = _ref.location;

  var CLASS_NAME = '';
  if (heading2 == '') {
    CLASS_NAME = 'single';
  } else if (location && location.length && location[0].address) {
    CLASS_NAME = 'address';
  } else if (location && location.length && location[0].percent) {
    CLASS_NAME = 'percent';
  }

  var contentString = getContent(CLASS_NAME, location);
  return _react2.default.createElement(
    'div',
    { className: 'list ' + CLASS_NAME },
    _react2.default.createElement(
      'h3',
      null,
      title
    ),
    _react2.default.createElement(
      'p',
      null,
      copy
    ),
    _react2.default.createElement(
      'div',
      { className: 'headings' },
      _react2.default.createElement(
        'p',
        null,
        heading1
      ),
      _react2.default.createElement(
        'p',
        null,
        heading2
      )
    ),
    contentString
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UnorderedList/UnorderedList.jsx
// module id = 1271
// module chunks = 0